'use strict';

var FormatMeetingId = function(meetingId, separator) {
    if (!angular.isDefined(separator)) separator = ' ';
    if (!angular.isString(meetingId)) return '';
    return meetingId.length > 6 && !isNaN(parseInt(meetingId, 10)) ? 
        meetingId.substr(0, 3) + separator + meetingId.substr(3, 3) + separator + meetingId.substr(6) : 
        meetingId;
};

module.exports = FormatMeetingId;